import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink, Link} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";
import Person from "@material-ui/icons/Person";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import DateRange from "@material-ui/icons/DateRange";
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {serverError} from '../../redux/global'

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from "components/Grid/GridContainer.jsx";

import {titleCase} from '../../util/globalHelper';
import {getDateConverter, dashboardRouter, getDateConverterReversal} from '../../util/globalHelper';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};
class OneAppointment extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            notFound: null,
            start_date: "",
            end_date: "",
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            open: true,
            type: ""
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.CreateAlert = this.CreateAlert.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    CallReadApi = (id) => {
        api.getAppointment({_id: id})
            .then(json => {
                this.setState({data: json.data.data[0]})
            }).catch(error => {
            this.setState({notFound: error})
        }).catch(error => {
            this.props.serverError(true);
        })
        ;

    };

    sendReminder(id) {
        api.sendReminder({_id: id})
            .then(json => {
                this.setState({sendReminder: json.data.data})
            }).catch(error => {
            this.props.serverError(true);
        })
        ;
        var msgcolor = {message: "Reminder Sent!", color: "success"};
        this.props.id.generateNotification(msgcolor);
    }

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.id);
    }



    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name

    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData} = this.state;
        const {classes} = this.props;
        if (this.state.data) {
            return (
                <div>
                    {this.state.alert}
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <DateRange/>
                                            </GridItem>
                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Appointment</h4>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer>
                                        <GridItem xs={12} md={8}>

                                            <GridItem>
                                                <h2>{data && data.patient_id && data.patient_id.user_id ? data.patient_id.user_id.name : "No Name"}
                                                    <NavLink color="info"
                                                                         to={dashboardRouter(`/patient/${data.patient_id._id}`)}
                                                                         style={{
                                                                             padding: 8,
                                                                             marginLeft: '10%',
                                                                             color: '#39abc1'
                                                                         }}>
                                                                    <Tooltip
                                                                        id="tooltip-top"
                                                                        title="View Patient Record"
                                                                        placement="bottom">
                                                                        <Icon color="info"
                                                                              style={{fontSize: 30}}>info</Icon>
                                                                    </Tooltip>
                                                                </NavLink>
                                                    {/*<Link
                                                        to={dashboardRouter(`/patient/${data.patient_id._id}`)}><Tooltip
                                                        id="tooltip-top"
                                                        title="View"
                                                        placement="bottom"
                                                        classes={{tooltip: this.props.classes.tooltip}}>
                                                        <Button type="button" color="info"
                                                                style={{
                                                                    padding: 8,
                                                                    marginLeft: '10%'
                                                                }}>
                                                            <Icon
                                                                style={{fontSize: 20}}>info</Icon>
                                                        </Button></Tooltip></Link>*/}
                                                </h2>
                                            </GridItem>

                                            <GridItem>

                                                <GridItem>
                                                    <h5>
                                                        <b>{data && data.patient_id.gender ? titleCase(data.patient_id.gender) : null}<br/>

                                                            {data.patient_id.user_id.age ? data.patient_id.user_id.age + " years" : null}

                                                        </b>

                                                    </h5>
                                                    <h5>
                                                        <b>Contact: {data && data.patient_id && data.patient_id.user_id ? data.patient_id.user_id.contact : null}</b>
                                                    </h5>
                                                    <h5>
                                                        <b>{data && data.patient_id && data.patient_id.user_id ? data.patient_id.user_id.email : null}</b>
                                                    </h5>
                                                </GridItem>
                                                <br /><br />
                                                <GridItem>
                                                    <h5>
                                                        <b>Doctor: {data && data.doctor_id ? data.doctor_id.user_id.name : null}</b>
                                                    </h5>
                                                </GridItem>
                                                <GridItem>
                                                    <h5>
                                                        <b>Service: {data && data.service_id ? data.service_id.service : null}</b>
                                                    </h5>
                                                </GridItem>
                                                {data && data.notes ? <GridItem>
                                                    <h5>
                                                        <b>Reason: { data.notes }</b>
                                                    </h5>
                                                </GridItem> : null}
                                                {data && data.status ? <GridItem>
                                                    <h5>
                                                        <b>Status: { data.status }</b>
                                                    </h5>
                                                </GridItem> : null}
                                            </GridItem>

                                            <GridItem>
                                                <br/>
                                                <br/>
                                            </GridItem>

                                        </GridItem>
                                        <GridItem>
                                            <GridItem>
                                                <br />
                                                <h3>{(data.local_date_string ? getDateConverterReversal(data.local_date_string) : getDateConverter(data.date_string))}, {data.local_start_time}</h3>

                                            </GridItem>
                                            <br /><br />
                                            <GridItem>
                                                <NavLink
                                                    to={dashboardRouter(`/appointment/update/${data._id}`)}>
                                                    <Button block className="width-full" color="warning">
                                                        <Icon>border_color</Icon>
                                                        <span style={{paddingLeft: 10}}>Update</span>
                                                    </Button>
                                                </NavLink>

                                                <br/>
                                                {/*<NavLink*/}
                                                {/*to={`/appointment/update/${data._id}`}>*/}
                                                <Button className="width-full"
                                                        color="grey" onClick={() => {
                                                    this.CreateAlert(`${data._id}`);
                                                }}>Cancel</Button>
                                                {/*</NavLink>*/}
                                                <br/>
                                                {/*<NavLink*/}
                                                {/*to={`/appointment/update/${data._id}`}>*/}
                                                <Button className="width-full"
                                                        color="info" onClick={() => this.sendReminder(data._id)}>Reminder</Button>
                                                {/*</NavLink>*/}
                                                <br/>
                                                <NavLink to={dashboardRouter(`/report/add/${data.patient_id._id}`)}>
                                                    <Button className="width-full"
                                                            color="success">Add Report</Button></NavLink>
                                                {/*<Button color="danger"*/}
                                                {/*onClick={this.DeleteAlert('Delete', data1.doctor_id)}*/}
                                                {/*>*/}
                                                {/*<Icon>delete</Icon>Delete</Button>*/}
                                            </GridItem>
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        }
        else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        }
        else return (
                <div>
                    <Loader/>
                </div>
            )
    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Are you sure want to cancel?"}</DialogTitle>
                    <DialogActions style={{margin: '8px auto'}}>
                        <Button color="danger" onClick={() => {
                            this.deleteRecord(id)
                        }}>
                            Delete
                        </Button>
                        <Button onClick={this.hideAlert}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"_id": id, "updated_object": {}}
        api.deleteAppointment(postBody)
            .then(json => {
                this.props.id.history.push(dashboardRouter(`/appointment/readAppointments`))
            }).catch(error => {
            this.props.serverError(true);
        })
        ;
    }

}

const mapStateToProps = ({global}) => ({
    searchPrescription: global.searchPrescription,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    serverError
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OneAppointment));


// WEBPACK FOOTER //
// ./src/components/Appointment/oneAppointment.jsx